import React, { useState } from "react";
import { Box } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { AuthLayout } from "../../../shared/components/layout/AuthLayout";
import TwoFAillustration from "../../../assets/illustrations/two-factor-auth.svg";
import FormButton from "../../../shared/components/ui/FormButton";

const LoginTwoFaView = ({
  loginState,
  setLoginState,
  handleLoginTwoFaVerification,
  isActionLoading,
  textFieldStyle,
}) => {
  const [code, setCode] = useState("");

  const onCodeChange = (value) => {
    setCode(value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await handleLoginTwoFaVerification(event, code, () => setCode(""));
  };

  return (
    <AuthLayout
      title="Enter 2FA Code"
      subtitle="Please enter the 6-digits code from your authenticator app to continue login."
      illustration={TwoFAillustration}
      headerContent={
        <div className="mb-8 lg:mb-14 xl:mb-16">
          <button
            onClick={() => setLoginState({ state: "login", message: null })}
            className="flex items-center gap-2 py-2 text-primary"
          >
            <ArrowBack fontSize="small" />
            <span className="text-sm font-medium">Back</span>
          </button>
        </div>
      }
    >
      <Box component="form" onSubmit={handleSubmit}>
        {/* <Typography
          variant="body2"
          className="text-center text-primary mb-4"
          sx={{ fontSize: "14px", fontWeight: 500 }}
        >
          Please Enter The Authentication Code From Your Authenticator App To Continue Login
        </Typography> */}

        <Box sx={{ display: "flex", justifyContent: "center", mb: 4, alignItems: "center", width: "100%" }}>
          <MuiOtpInput
            value={code}
            onChange={onCodeChange}
            length={6}
            autoFocus
            onComplete={(completedValue) => undefined}
            TextFieldsProps={{
              disabled: false,
              error: Boolean(loginState.message),
            }}
            sx={{
              width: "100%",
              maxWidth: {  sm: "100%" },
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              mx: "auto",
              "& .MuiOtpInput-Box": {
                width: "100%",
                justifyContent: { xs: "space-between", sm: "center" },
                gap: { xs: 0, sm: "20px" },
                flexWrap: "nowrap",
              },
              "& .MuiOutlinedInput-root": {
                width: { xs: "44px", sm: "54px" },
                height: { xs: "48px", sm: "54px" },
                margin: 0,
                borderRadius: "8px",
                fontSize: { xs: "18px", sm: "20px" },
                fontWeight: 600,
              },
              "& .MuiOutlinedInput-input": {
                textAlign: "center",
                padding: "0",
              },
            }}
          />
        </Box>

        <FormButton
          type="submit"
          variant="contained"
          fullWidth
          size="medium"
          sx={{ backgroundColor: "primary.main" }}
          disabled={code.length !== 6 || isActionLoading}
          loading={isActionLoading}
        >
          Verify Code
        </FormButton>
      </Box>
    </AuthLayout>
  );
};

export default LoginTwoFaView;
